module.exports = __webpack_public_path__ + "img/f1-2-icon5.6cdbd3a6.png";